import requests from "./httpServices";

const OrderServices = {

  createOrderApi: async (body) => {
    return requests.post("/orders", body);
  },

  removeOrderApi: async (id) => {
    return requests.delete(`/orders/${id}`, { "force": true });
  },

  getAllOrdersApi: async (params) => {
    return requests.get("/orders", params);
  },

  uploadSignature: async (body) => {
    return requests.post("/custom-api/v1/capture_customer_signature", body);
  },
  createCheckoutUrlApi: async ({ customerId, items }) => {
    return requests.post("/api/stripe/checkout-url", {
      customerId,
      items,
    });
  },
};

export default OrderServices;
